/*
Replace
recipeStep with your resource Name :) Take care about different writings!
/!\ RecipeStep recipeStep RecipeSteps recipeSteps /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const recipeStepSlice = createSlice({
  name: "recipeSteps",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listRecipeSteps,
  show: showRecipeStep,
  create: createRecipeStep,
  update: updateRecipeStep,
} = recipeStepSlice.actions;

export const actions = recipeStepSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const recipeSteps = (state) =>
  state.recipeSteps.idsList.map((id) => state.recipeSteps.dictionary[id]);
export const recipeStep = (state) =>
  state.recipeSteps.showId &&
  state.recipeSteps.dictionary[state.recipeSteps.showId];
export const recipeStepAttributes = (state) => recipeStep(state)?.attributes;
export const recipeStepRelationships = (state) =>
  recipeStep(state)?.relationships;
export const recipeStepId = (state) => state.recipeSteps.showId;

export const getRecipeStep = createSelector(
  (state) => state.recipeSteps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getRecipeStepAttributes = createSelector(
  (state) => state.recipeSteps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getRecipeStepRelationships = createSelector(
  (state) => state.recipeSteps.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getRecipeSteps = createSelector(
  (state) => state.recipeSteps.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default recipeStepSlice.reducer;
